"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4152,5384,2012],{

/***/ 66221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hj": function() { return /* binding */ getProductsAvailability; }
});

// UNUSED EXPORTS: getProductOrBundle, getProducts

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../packages/commerce/src/lib/apollo.js + 13 modules
var apollo = __webpack_require__(67027);
// EXTERNAL MODULE: ../../packages/commerce/src/utils/error.js
var error = __webpack_require__(38102);
// EXTERNAL MODULE: ../../packages/sf-modules/src/index.js + 26 modules
var src = __webpack_require__(37555);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(60138);
// EXTERNAL MODULE: ../../packages/commerce/src/graphql/fragments/products/ProductReviewFields.gql.js
var ProductReviewFields_gql = __webpack_require__(3667);
;// CONCATENATED MODULE: ../../packages/commerce/src/graphql/fragments/products/ProductFields.gql.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    fragment ProductFields on Product {\n        id\n        gtin\n        name\n        slug\n        brand\n        seoDescription\n        description\n        longDescription\n        isBundle\n        reviewAverage\n        reviewCount\n        fiveStarReviewCount\n        fourStarReviewCount\n        threeStarReviewCount\n        twoStarReviewCount\n        oneStarReviewCount\n        reviews(first: 10) {\n            edges {\n                cursor\n                node {\n                    ...ProductReviewFields\n                }\n            }\n        }\n        prices(first: 1) {\n            edges {\n                node {\n                    id\n                    netPrice\n                    grossPrice\n                }\n            }\n        }\n        stockUnit\n        checkoutMaxQuantity\n        sellingType\n        sellingValue\n        sellingUnit\n        weightPerPieceValue\n        weightPerPieceUnit\n        incrementValue\n        incrementUnit\n        backgroundColor\n        blobs {\n            color\n            borderColor\n            borderRadius\n            borderStyle\n            borderWidth\n            fontColor\n            word\n        }\n        certifications {\n            id\n            name\n            description\n            external\n            logoUrl\n        }\n        ingredients {\n            id\n            name\n            position\n            breakdown\n            percentage\n        }\n        story\n        mainImage\n        images {\n            isMain\n            alt\n            url\n            order\n            isHover\n            isInCollapsedSection\n        }\n        facets {\n            value {\n                name\n            }\n            description\n            isMain\n        }\n        aisles {\n            main\n            firstLevel {\n                name\n                slug\n            }\n            secondLevel {\n                name\n                slug\n            }\n            thirdLevel {\n                name\n                slug\n            }\n        }\n        variant {\n            id\n            sku\n            pricing {\n                price\n                priceUndiscounted\n                baseMeasurePrice\n                baseMeasurePriceUndiscounted\n            }\n        }\n        plmId\n        rawId\n        analyticsId\n        barcodes\n        itemStatus\n        itemType\n        sku @client\n        href @client\n        mainImageAlt @client\n        stepperIncrement @client\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/**
 * GraphQL Fragment
 *
 */ var ProductFieldsFragment = (0,lib/* gql */.Ps)(_templateObject(), ProductReviewFields_gql/* ProductReviewFieldsFragment */.C);

;// CONCATENATED MODULE: ../../packages/commerce/src/graphql/queries/products/product-details.gql.js

function product_details_gql_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    query Product(\n        $slug: String\n        $productId: String\n        $withAvailability: Boolean = false\n        $zipCode: String\n    ) {\n        product(slug: $slug, productId: $productId) {\n            ...ProductFields\n        }\n        productAvailability(slug: [$slug], zipCode: $zipCode) @include(if: $withAvailability) {\n            gtin\n            availableOnZipCode\n            itemsAvailable\n            status\n        }\n    }\n"
    ]);
    product_details_gql_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var product_details_gql_PRODUCT_DETAILS_QUERY = (0,lib/* gql */.Ps)(product_details_gql_templateObject(), ProductFieldsFragment);
/* harmony default export */ var product_details_gql = ((/* unused pure expression or super */ null && (product_details_gql_PRODUCT_DETAILS_QUERY)));

;// CONCATENATED MODULE: ../../packages/commerce/src/graphql/fragments/products/BundleFields.gql.js

function BundleFields_gql_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    fragment BundleFields on Bundle {\n        id\n        name\n        slug\n        sku\n        brand\n        description\n        longDescription\n        seoDescription\n        totalPrice\n        checkoutMaxQuantity\n        bundleAisle {\n            main\n            firstLevel {\n                name\n                slug\n            }\n            secondLevel {\n                name\n                slug\n            }\n            thirdLevel {\n                name\n                slug\n            }\n        }\n        blobs {\n            color\n            borderColor\n            borderRadius\n            borderStyle\n            borderWidth\n            fontColor\n            word\n        }\n        images {\n            alt\n            url\n            order\n        }\n        facets {\n            value {\n                name\n            }\n            description\n            isMain\n        }\n        certifications {\n            id\n            name\n            description\n            external\n            logoUrl\n        }\n        products {\n            ...ProductFields\n            quantity\n        }\n\n        barcodes\n        rawId\n        plmId\n\n        gtin @client\n        isBundle @client\n        href @client\n        mainImage @client\n        mainImageAlt @client\n        sellingValue @client\n        sellingUnit @client\n    }\n"
    ]);
    BundleFields_gql_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/**
 * GraphQL Fragment
 *
 */ var BundleFieldsFragment = (0,lib/* gql */.Ps)(BundleFields_gql_templateObject(), ProductFieldsFragment);

;// CONCATENATED MODULE: ../../packages/commerce/src/graphql/queries/products/kit-details.gql.js

function kit_details_gql_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    query Bundle($slug: String!, $withAvailability: Boolean = false, $zipCode: String) {\n        bundle(slug: $slug) {\n            ...BundleFields\n        }\n        productAvailability(slug: [$slug], zipCode: $zipCode) @include(if: $withAvailability) {\n            gtin\n            availableOnZipCode\n            itemsAvailable\n            status\n        }\n    }\n"
    ]);
    kit_details_gql_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var kit_details_gql_KIT_DETAILS_QUERY = (0,lib/* gql */.Ps)(kit_details_gql_templateObject(), BundleFieldsFragment);
/* harmony default export */ var kit_details_gql = ((/* unused pure expression or super */ null && (kit_details_gql_KIT_DETAILS_QUERY)));

;// CONCATENATED MODULE: ../../packages/commerce/src/graphql/fragments/products/ProductFieldsForCardWithPrice.gql.js

function ProductFieldsForCardWithPrice_gql_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment ProductFieldsForCardWithPrice on Product {\n        id\n        gtin\n        name\n        slug\n        brand\n        isBundle\n        reviewAverage\n        reviewCount\n        stockUnit\n        checkoutMaxQuantity\n        mainImage\n        sellingType\n        sellingValue\n        sellingUnit\n        weightPerPieceValue\n        weightPerPieceUnit\n        incrementValue\n        incrementUnit\n\n        plmId\n        rawId\n        analyticsId\n\n        sku @client\n        href @client\n        mainImageAlt @client\n        stepperIncrement @client\n    }\n"
    ]);
    ProductFieldsForCardWithPrice_gql_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/**
 * GraphQL Fragment
 *
 */ var ProductFieldsForCardWithPriceFragment = (0,lib/* gql */.Ps)(ProductFieldsForCardWithPrice_gql_templateObject());

// EXTERNAL MODULE: ../../packages/commerce/src/graphql/fragments/products/BundleFieldsForCard.gql.js
var BundleFieldsForCard_gql = __webpack_require__(2762);
;// CONCATENATED MODULE: ../../packages/commerce/src/graphql/queries/products/products-bundles-card-details.gql.js

function products_bundles_card_details_gql_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    ",
        "\n    query ProductsAndBundles(\n        $plmId: [String]\n        $productIds: [String]\n        $bundleIds: [String]\n        $sku: [String]\n        $zipCode: String\n        $storeId: ID\n        $withApplicableRules: Boolean = false\n        $withAvailability: Boolean = false\n        $withCatalogPrice: Boolean = false\n        $withProducts: Boolean = false\n        $withBundles: Boolean = false\n        $nbProducts: Int = 1\n        $nbBundles: Int = 1\n    ) {\n        products(productId: $productIds, sku: $sku, plmId: $plmId, first: $nbProducts)\n            @include(if: $withProducts) {\n            totalCount\n            edges {\n                node {\n                    ...ProductFieldsForCardWithPrice\n                    applicableRules(storeId: $storeId) @include(if: $withApplicableRules) {\n                        id\n                        title\n                        description\n                        campaignIcon\n                        priority\n                        conditions {\n                            id\n                            includeAll\n                            type\n                            evaluationType\n                            objects\n                        }\n                        benefits {\n                            id\n                            discountString\n                            type\n                        }\n                    }\n                }\n            }\n        }\n        bundles(bundleId: $bundleIds, first: $nbBundles) @include(if: $withBundles) {\n            totalCount\n            edges {\n                node {\n                    ...BundleFieldsForCard\n                    applicableRules(storeId: $storeId) @include(if: $withApplicableRules) {\n                        id\n                        title\n                        description\n                        campaignIcon\n                        priority\n                        conditions {\n                            id\n                            includeAll\n                            type\n                            evaluationType\n                            objects\n                        }\n                        benefits {\n                            id\n                            discountString\n                            type\n                        }\n                    }\n                }\n            }\n        }\n        productAvailability(productId: $productIds, zipCode: $zipCode)\n            @include(if: $withAvailability) {\n            gtin\n            availableOnZipCode\n            itemsAvailable\n            status\n        }\n        catalogPrice(storeId: $storeId, sku: $sku) @include(if: $withCatalogPrice) {\n            sku\n            isBundle\n            price\n            discountedPrice\n            baseMeasurePrice\n            baseMeasureDiscountedPrice\n        }\n    }\n"
    ]);
    products_bundles_card_details_gql_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var products_bundles_card_details_gql_PRODUCTS_AND_BUNDLES_CARD_DETAILS_QUERY = (0,lib/* gql */.Ps)(products_bundles_card_details_gql_templateObject(), ProductFieldsForCardWithPriceFragment, BundleFieldsForCard_gql/* BundleFieldsForCardFragment */.W);
/* harmony default export */ var products_bundles_card_details_gql = ((/* unused pure expression or super */ null && (products_bundles_card_details_gql_PRODUCTS_AND_BUNDLES_CARD_DETAILS_QUERY)));

;// CONCATENATED MODULE: ../../packages/commerce/src/graphql/queries/products/product-availability-and-price.gql.js

function product_availability_and_price_gql_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query CatalogPriceAndAvailability(\n        $productIds: [String]\n        $plmId: [String]\n        $slugs: [String]\n        $sku: [String]\n        $bundleId: [String]\n        $zipCode: String\n        $storeId: ID\n    ) {\n        productAvailability(\n            sku: $sku\n            productId: $productIds\n            plmId: $plmId\n            bundleId: $bundleId\n            slug: $slugs\n            zipCode: $zipCode\n        ) {\n            gtin\n            availableOnZipCode\n            itemsAvailable\n            status\n        }\n        catalogPrice(\n            sku: $sku\n            storeId: $storeId\n            plmId: $plmId\n            bundleId: $bundleId\n            productId: $productIds\n        ) {\n            sku\n            isBundle\n            price\n            discountedPrice\n            baseMeasurePrice\n            baseMeasureDiscountedPrice\n            discountPercentage\n            discountValidUntil\n        }\n    }\n"
    ]);
    product_availability_and_price_gql_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PRODUCT_AVAILABILITY_AND_PRICE_QUERY = (0,lib/* gql */.Ps)(product_availability_and_price_gql_templateObject());
/* harmony default export */ var product_availability_and_price_gql = (PRODUCT_AVAILABILITY_AND_PRICE_QUERY);

// EXTERNAL MODULE: ./constants/constants.js
var constants = __webpack_require__(67546);
;// CONCATENATED MODULE: ./functions/fnRequestAPIs/fnProductsAPI.js













/** Get products from PIM */ function getProducts(_) {
    return _getProducts.apply(this, arguments);
}
function _getProducts() {
    _getProducts = _async_to_generator(regeneratorRuntime.mark(function _callee(param) {
        var _productPLMIds, productPLMIds, _productsGtins, productsGtins, _bundlesId, bundlesId, _zipCode, zipCode, _storeId, storeId, _withApplicableRules, withApplicableRules, queryVariables, client, gtinsString, response, data, products, bundles;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _productPLMIds = param.productPLMIds, productPLMIds = _productPLMIds === void 0 ? [] : _productPLMIds, _productsGtins = param.productsGtins, productsGtins = _productsGtins === void 0 ? [] : _productsGtins, _bundlesId = param.bundlesId, bundlesId = _bundlesId === void 0 ? [] : _bundlesId, _zipCode = param.zipCode, zipCode = _zipCode === void 0 ? "" : _zipCode, _storeId = param.storeId, storeId = _storeId === void 0 ? null : _storeId, _withApplicableRules = param.withApplicableRules, withApplicableRules = _withApplicableRules === void 0 ? false : _withApplicableRules;
                    if (!(!productsGtins && !bundlesId || !productsGtins.length && !bundlesId.length)) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        products: [],
                        bundles: [],
                        availabilities: [],
                        catalogPrices: []
                    });
                case 3:
                    queryVariables = {};
                    if (productPLMIds.length) {
                        queryVariables.plmId = productPLMIds;
                    } else {
                        queryVariables.sku = productsGtins;
                    }
                    client = initializeApollo();
                    gtinsString = _to_consumable_array(productsGtins).concat(_to_consumable_array(bundlesId)); // Hack until this is modified in Saleor: gtins should be the same type.
                    _ctx.next = 9;
                    return client.query({
                        query: PRODUCTS_AND_BUNDLES_CARD_DETAILS_QUERY,
                        context: {
                            timeout: APOLLO_GRAPHQL_TIMEOUT
                        },
                        variables: _object_spread_props(_object_spread({}, queryVariables), {
                            zipCode: zipCode,
                            storeId: storeId,
                            withApplicableRules: withApplicableRules,
                            withAvailability: Boolean(zipCode && gtinsString.length),
                            withCatalogPrice: Boolean(storeId && gtinsString.length),
                            withProducts: Boolean(productsGtins.length),
                            withBundles: Boolean(bundlesId.length),
                            nbProducts: productsGtins.length,
                            nbBundles: bundlesId.length
                        }),
                        fetchPolicy: "network-only"
                    });
                case 9:
                    response = _ctx.sent;
                    data = get_(response, [
                        "data"
                    ]);
                    products = get_(data, [
                        "products",
                        "edges"
                    ], []).map(function(item) {
                        return get_(item, [
                            "node"
                        ], {});
                    });
                    bundles = get_(data, [
                        "bundles",
                        "edges"
                    ], []).map(function(item) {
                        return get_(item, [
                            "node"
                        ], {});
                    });
                    return _ctx.abrupt("return", _object_spread_props(_object_spread({}, response), {
                        products: products,
                        bundles: bundles,
                        availabilities: get_(data, [
                            "productAvailability"
                        ], []),
                        catalogPrices: get_(data, [
                            "catalogPrice"
                        ], [])
                    }));
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getProducts.apply(this, arguments);
}
function getProductsAvailability(_) {
    return _getProductsAvailability.apply(this, arguments);
}
function _getProductsAvailability() {
    _getProductsAvailability = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var _gtins, gtins, _productIds, productIds, _plmIds, plmIds, _zipCode, zipCode, _storeId, storeId, client, queryVariables, response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _gtins = param.gtins, gtins = _gtins === void 0 ? [] : _gtins, _productIds = param.productIds, productIds = _productIds === void 0 ? [] : _productIds, _plmIds = param.plmIds, plmIds = _plmIds === void 0 ? [] : _plmIds, _zipCode = param.zipCode, zipCode = _zipCode === void 0 ? "" : _zipCode, _storeId = param.storeId, storeId = _storeId === void 0 ? null : _storeId;
                    if (!(!(plmIds === null || plmIds === void 0 ? void 0 : plmIds.length) && !(productIds === null || productIds === void 0 ? void 0 : productIds.length) && !(gtins === null || gtins === void 0 ? void 0 : gtins.length))) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", {});
                case 3:
                    client = (0,apollo/* initializeApollo */["in"])();
                    queryVariables = {};
                    if (plmIds && plmIds.length) {
                        queryVariables.plmId = plmIds;
                    } else if (productIds && productIds.length) {
                        queryVariables.productIds = productIds;
                    } else {
                        queryVariables.sku = gtins;
                    }
                    _ctx.next = 8;
                    return client.query({
                        query: product_availability_and_price_gql,
                        context: {
                            timeout: constants/* APOLLO_GRAPHQL_TIMEOUT */.Tx
                        },
                        variables: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, queryVariables), {
                            zipCode: zipCode,
                            storeId: storeId
                        }),
                        fetchPolicy: "network-only"
                    }).then(function(res) {
                        return res;
                    }).catch(function(e) {
                        (0,error/* trackError */.t)({
                            error: e,
                            extras: {
                                label: "No se encontraron productos",
                                productId: productIds,
                                gtins: gtins,
                                zipCode: zipCode,
                                error: e
                            }
                        });
                        return null;
                    });
                case 8:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", {
                        availabilities: (0,src/* get_ */.jR)(response, [
                            "data",
                            "productAvailability"
                        ], []),
                        prices: (0,src/* get_ */.jR)(response, [
                            "data",
                            "catalogPrice"
                        ], [])
                    });
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getProductsAvailability.apply(this, arguments);
}
function getProductOrBundle(_) {
    return _getProductOrBundle.apply(this, arguments);
}
function _getProductOrBundle() {
    _getProductOrBundle = _async_to_generator(regeneratorRuntime.mark(function _callee(param) {
        var client, slug, _isBundle, isBundle, responseProduct, data, bundleOrProductKey, availability;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    client = param.client, slug = param.slug, _isBundle = param.isBundle, isBundle = _isBundle === void 0 ? false : _isBundle;
                    if (slug) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 3:
                    ;
                    _ctx.prev = 4;
                    _ctx.next = 7;
                    return client.query({
                        query: isBundle ? KIT_DETAILS_QUERY : PRODUCT_DETAILS_QUERY,
                        context: {
                            timeout: APOLLO_GRAPHQL_TIMEOUT
                        },
                        variables: {
                            slug: slug,
                            withAvailability: true,
                            zipCode: ""
                        },
                        fetchPolicy: "network-only"
                    });
                case 7:
                    responseProduct = _ctx.sent;
                    _ctx.next = 12;
                    break;
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](4);
                case 12:
                    if (responseProduct) {
                        _ctx.next = 14;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 14:
                    data = get_(responseProduct, [
                        "data"
                    ]);
                    bundleOrProductKey = isBundle ? "bundle" : "product";
                    availability = get_(data, [
                        "productAvailability",
                        0
                    ]);
                    return _ctx.abrupt("return", _object_spread_props(_object_spread({}, responseProduct), {
                        product: dataTransformers.transformProductOrBundleFromPIM(isBundle, get_(data, [
                            bundleOrProductKey
                        ]), availability, true),
                        productBreadcrumb: dataTransformers.getProductBreadcrumb(get_(data, [
                            bundleOrProductKey
                        ]), isBundle)
                    }));
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                10
            ]
        ]);
    }));
    return _getProductOrBundle.apply(this, arguments);
}


/***/ }),

/***/ 18009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ fetchProductsPromotions; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../packages/sf-modules/src/index.js + 26 modules
var src = __webpack_require__(37555);
// EXTERNAL MODULE: ../../packages/commerce/src/lib/apollo.js + 13 modules
var apollo = __webpack_require__(67027);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(60138);
;// CONCATENATED MODULE: ../../packages/commerce/src/graphql/queries/products/products-bundles-applicable-rules.gql.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query ProductsAndBundlesApplicableRules(\n        $productIds: [String]\n        $sku: [String]\n        $plmId: [String]\n        $bundlesID: [String!]\n        $firstGtins: Int\n        $firstBundles: Int\n        $storeId: ID\n    ) {\n        products(productId: $productIds, plmId: $plmId, sku: $sku, first: $firstGtins) {\n            totalCount\n            edges {\n                cursor\n                node {\n                    id\n                    gtin\n                    applicableRules(storeId: $storeId) {\n                        id\n                        title\n                        campaignIcon\n                        priority\n                        conditions {\n                            id\n                            includeAll\n                            type\n                            evaluationType\n                            objects\n                        }\n                    }\n                }\n            }\n        }\n        bundles(bundleId: $bundlesID, first: $firstBundles) {\n            totalCount\n            edges {\n                cursor\n                node {\n                    id\n                    sku\n                    applicableRules(storeId: $storeId) {\n                        id\n                        title\n                        campaignIcon\n                        priority\n                        conditions {\n                            id\n                            includeAll\n                            type\n                            evaluationType\n                            objects\n                        }\n                    }\n                }\n            }\n        }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PRODUCTS_BUNDLES_APPLICABLE_RULES_QUERY = (0,lib/* gql */.Ps)(_templateObject());
/* harmony default export */ var products_bundles_applicable_rules_gql = (PRODUCTS_BUNDLES_APPLICABLE_RULES_QUERY);

// EXTERNAL MODULE: ./constants/constants.js
var constants = __webpack_require__(67546);
;// CONCATENATED MODULE: ./functions/fnRequestAPIs/fnProductsPromotion.js








var client = (0,apollo/* initializeApollo */["in"])();
function fetchProductsPromotions(_) {
    return _fetchProductsPromotions.apply(this, arguments);
}
function _fetchProductsPromotions() {
    _fetchProductsPromotions = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var _gtinsToFetch, gtinsToFetch, _productIds, productIds, _plmIds, plmIds, _bundlesIdToFetch, bundlesIdToFetch, _storeId, storeId, queryVariables, productsAndBundlesPromotions, productsPromotions, bundlesPromotions;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _gtinsToFetch = param.gtinsToFetch, gtinsToFetch = _gtinsToFetch === void 0 ? [] : _gtinsToFetch, _productIds = param.productIds, productIds = _productIds === void 0 ? [] : _productIds, _plmIds = param.plmIds, plmIds = _plmIds === void 0 ? [] : _plmIds, _bundlesIdToFetch = param.bundlesIdToFetch, bundlesIdToFetch = _bundlesIdToFetch === void 0 ? [] : _bundlesIdToFetch, _storeId = param.storeId, storeId = _storeId === void 0 ? null : _storeId;
                    if (!(!(gtinsToFetch === null || gtinsToFetch === void 0 ? void 0 : gtinsToFetch.length) && !(productIds === null || productIds === void 0 ? void 0 : productIds.length) && !(plmIds === null || plmIds === void 0 ? void 0 : plmIds.length))) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 3:
                    queryVariables = {};
                    if (plmIds && plmIds.length) {
                        queryVariables.plmId = plmIds;
                    } else if (productIds && productIds.length) {
                        queryVariables.productIds = productIds;
                    } else {
                        queryVariables.sku = gtinsToFetch;
                    }
                    _ctx.next = 7;
                    return client.query({
                        query: products_bundles_applicable_rules_gql,
                        context: {
                            timeout: constants/* APOLLO_GRAPHQL_TIMEOUT */.Tx
                        },
                        variables: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, queryVariables), {
                            bundlesID: bundlesIdToFetch,
                            firstGtins: gtinsToFetch && gtinsToFetch.length ? gtinsToFetch.length : 1,
                            firstBundles: bundlesIdToFetch && bundlesIdToFetch.length ? bundlesIdToFetch.length : 1,
                            storeId: storeId
                        })
                    });
                case 7:
                    productsAndBundlesPromotions = _ctx.sent;
                    productsPromotions = (0,src/* get_ */.jR)(productsAndBundlesPromotions, [
                        "data",
                        "products",
                        "edges"
                    ], []).map(function(p) {
                        return (0,src/* get_ */.jR)(p, [
                            "node"
                        ]);
                    });
                    bundlesPromotions = (0,src/* get_ */.jR)(productsAndBundlesPromotions, [
                        "data",
                        "bundles",
                        "edges"
                    ], []).map(function(p) {
                        return (0,src/* get_ */.jR)(p, [
                            "node"
                        ]);
                    });
                    return _ctx.abrupt("return", {
                        productsPromotions: productsPromotions,
                        bundlesPromotions: bundlesPromotions
                    });
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetchProductsPromotions.apply(this, arguments);
}


/***/ }),

/***/ 2762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ BundleFieldsForCardFragment; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment BundleFieldsForCard on Bundle {\n        id\n        name\n        slug\n        sku\n        brand\n        checkoutMaxQuantity\n        stockQuantity\n        totalPrice\n        images {\n            alt\n            url\n            order\n        }\n        products {\n            id\n            gtin\n            name\n            quantity\n        }\n\n        rawId\n        plmId\n\n        gtin @client\n        isBundle @client\n        href @client\n        mainImage @client\n        mainImageAlt @client\n        sellingValue @client\n        sellingUnit @client\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/**
 * GraphQL Fragment
 *
 */ var BundleFieldsForCardFragment = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 3667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ ProductReviewFieldsFragment; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60138);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    fragment ProductReviewFields on ProductReview {\n        id\n        productName\n        productSku\n        reviewerName\n        rating\n        title\n        content\n        isVerified\n        created\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/**
 * GraphQL Fragment
 *
 */ var ProductReviewFieldsFragment = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 66483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var sf_modules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37555);





/**
 * Use our custom loader on Google Cloud Functions, linked to Google Storage
 * instead of next default loader
 */ var customLoader = function(param) {
    var src = param.src, width = param.width, quality = param.quality;
    return sf_modules__WEBPACK_IMPORTED_MODULE_3__/* .imageTools.getOptimizedImageURL */ .d$.getOptimizedImageURL(src, {
        w: width,
        q: quality || 70
    });
};
var Image = function(props) {
    if (!props || !props.src) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    var imageLoader = props.src.startsWith("https://us-central1-yema-") ? {
        loader: customLoader
    } // YEMA CDN Loader
     : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, imageLoader, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 4740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Image__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66483);



/***/ }),

/***/ 73769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);







var Link = function(_param) {
    var className = _param.className, context = _param.context, underline = _param.underline, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "context",
        "underline",
        "children"
    ]);
    var href = props === null || props === void 0 ? void 0 : props.href;
    var rootClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, "cursor-pointer", {
        "relative inline-block underline": underline,
        "text-ui-error": context === "danger"
    });
    if (!href || href === "") {
        var linkProps = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            className: rootClass,
            "aria-label": (props === null || props === void 0 ? void 0 : props.label) || "",
            rel: (props === null || props === void 0 ? void 0 : props.target) === "_blank" ? "noopener noreferrer" : ""
        }, props);
        delete linkProps.shallow;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, linkProps), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: rootClass
    }, props), {
        children: children
    }));
};
Link.defaultProps = {
    context: null,
    underline: true,
    target: "_self",
    shallow: false
};
Link.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    style: prop_types__WEBPACK_IMPORTED_MODULE_6__.object,
    context: prop_types__WEBPACK_IMPORTED_MODULE_6__.oneOf([
        "",
        "danger"
    ]),
    underline: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    href: prop_types__WEBPACK_IMPORTED_MODULE_6__.oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_6__.object
    ]),
    prefetch: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    target: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    onClick: prop_types__WEBPACK_IMPORTED_MODULE_6__.func,
    label: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    shallow: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 35384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _Link__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73769);



/***/ }),

/***/ 32012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ NotFound_NotFound; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Link/index.js
var Link = __webpack_require__(35384);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Image/index.js
var Image = __webpack_require__(4740);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Button/index.js + 1 modules
var Button = __webpack_require__(62772);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/NotFound/NotFound.jsx










var NOT_FOUND_IMAGE = "https://us-central1-yema-cdn.cloudfunctions.net/cdn/api/v1/yema-plm/images/view/assets/yema-image-notfound.png";
var NotFound = function(_param) {
    var className = _param.className, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "robots",
                    content: "noindex"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: classnames_default()("relative h-96 md:h-[607px]", className)
            }, otherProps), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        layout: "fill",
                        objectFit: "cover",
                        objectPosition: "center",
                        src: NOT_FOUND_IMAGE,
                        alt: "La p\xe1gina que buscas no existe"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute top-0 w-full py-6 text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "\xa1Ups! Parece que llegaste a un lugar inesperado"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "No pasa nada"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variants: "primary",
                                    size: "sm",
                                    type: "button",
                                    children: "Regresar al inicio"
                                })
                            })
                        ]
                    })
                ]
            }))
        ]
    });
};
NotFound.defaultProps = {};
NotFound.propTypes = {};
/* harmony default export */ var NotFound_NotFound = (NotFound);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/NotFound/index.js



/***/ })

}]);